import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingLeft: 35,
      paddingRight: 35,
    },
    center: {
      textAlign: 'center',
    },
    left: {
      textAlign: 'left',
    },
    right: {
      textAlign: 'right',
    },
  }),
)

/**
 * 使用許諾
 * @returns
 */
const O_License = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <h2 className={classes.center}>「ジャペル納品受領システム」使用承諾</h2>
      <h3 className={classes.center}>
        <p className={classes.left}>ジャペル株式会社（以下「当社」といいます）はWebサービスを使用して商品を受領するシステム（以下「本システム」といいます）を提供しています。</p>
        <p className={classes.left}>
          本サービスを利用するには、本規約に同意の上で、本システムにて登録を行う必要があります。
          <br />
          尚、この登録が行われた時点で、当社は当該登録手続者が本規約に同意しているものとみなします。
        </p>
      </h3>
      <br />
      <ol>
        <li>本システムの利用</li>
        <p>本システムは、当社が運営するWebサービスであり、商品受領の業務をWeb上で完結させるシステムです。</p>
        <p>本システムを利用するためには、利用者はシステムへのユーザー登録が必要となります。登録の際には、ユーザー名、メールアドレス等の情報を登録する必要があります。</p>
        <p>ユーザー登録情報は、本システムの運用以外の目的で使用することはありません。また、適切に管理されます。</p>
        <p>本システムより納品データ登録の連絡後、7日を経過すると自動的に受領されるものとします。</p>
        <li>ユーザーの責任</li>
        <p>ユーザーは、本システムを利用するために必要な機器や通信環境を自らの責任で準備するものとします。</p>
        <p>ユーザーは、本システムを利用して行う一切の行為について責任を負うものとします。</p>
        <p>ユーザーは、本システムを利用して第三者に損害を与えた場合、自己の責任と費用で当該損害を賠償するものとします。</p>
        <p>ユーザーは、利用に際して登録した情報（メールアドレスやパスワード等を含みます）について、自己の責任の下、任意に登録、管理するものとします。</p>
        <p>パスワード等の管理不十分、使用上の過誤、第三者の使用、登録情報の漏洩によって生じる第三者の不正アクセス等による損害の責任はユーザーが負うものとします。</p>
        <li>当社の責任</li>
        <p>当社は、本システムの提供にあたり、細心の注意を払いますが、本システムの利用に起因する損害（当社の故意または重過失による場合を除きます）について一切の責任を負いません。</p>
        <p>当社は、本システムの利用を制限または中断する場合がありますが、これによりユーザーに損害が生じた場合でも、当社は一切の責任を負いません。</p>
        <li>改定</li>
        <p>当社は、本使用承諾内容を随時改定することができるものとします。改定後の使用承諾内容は、本システムに登録された時点で効力を生じるものとします。</p>
      </ol>
      <div className={classes.right}>
        <p>以上</p>
        <p></p>
        <p>
          2024年4月1日
          <br />
          ジャペル株式会社
        </p>
      </div>
      <br />
    </div>
  )
}
export default React.memo(O_License)
